<template>
  <div>
    <div class="card mb-20" @click="gotoDetail(item.id)" v-if="item">
      <div class="card_imgBox">
        <img v-lazy="item.classify_image" class="testImg" />
      </div>
      <div class="detail">
        <p class="h2">{{ item.title }}</p>
        <p>
          <b class="orange">￥{{ item.discount_price }}</b>
          <s class="gray ml-5 f10">￥{{ item.original_price }}</s>
          <span class="right">{{ item.evaluation_times }}人已测</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import store from "./../store/index";
export default {
  name: "Card",
  props: {
    item: Object,
  },
  data() {
    return {};
  },
  created() {
    console.log(this.item);
  },
  watch: {
    item(val) {
      this.item = val;
    },
  },
  methods: {
    // 跳转测评详情页
    gotoDetail(id) {
      // console.log(id, 'goto')
      store.commit("set_eval_id", id);
      this.$router.push("/test/" + id);
    },
  },
};
</script>

<style lang='less' scoped>
@import "~Style/index.less";
.card {
  width: 100%;
  display: flex;
  .card_imgBox {
    .w(120);
    height: 96px;
  }
  .testImg {
    width: 100%;
    border-radius: 12px;
    height: 100%;
  }
  .detail {
    width: 70%;
    margin-left: 17px;
    font-size: 15px;
    text-align: start;
    padding-top: 10px;
    .h2 {
      height: 1.6rem;
      line-height: 0.586667rem;
    }
    .discount {
      color: gray;
      font-size: smaller;
    }
    .right {
      float: right;
      margin-right: 10px;
      font-size: 12px;
      color: #4a4a4a;
    }
  }
}
</style>